import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: []
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setItems: (state, action) => {
            state.items = action.payload;
        },
        // other reducers
    },
});

export const { setItems } = appSlice.actions;
export const items = (state) => state.app.items;
export default appSlice.reducer;
